export default __webpack_public_path__ + "static/media/AndroidQR.a02acc2e.png";